import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

class UserClient {
  constructor(instance) {
    _defineProperty(this, "instance", void 0);

    this.instance = instance;
  }

  getChannelData(params) {
    var _this = this;

    return _asyncToGenerator(function* () {
      var result = yield _this.instance.client().makeRequest({
        method: "GET",
        url: "/v1/users/".concat(_this.instance.userId, "/channel_data/").concat(params.channelId)
      });
      return _this.handleResponse(result);
    })();
  }

  setChannelData(_ref) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      var {
        channelId,
        channelData
      } = _ref;
      var result = yield _this2.instance.client().makeRequest({
        method: "PUT",
        url: "/v1/users/".concat(_this2.instance.userId, "/channel_data/").concat(channelId),
        data: {
          data: channelData
        }
      });
      return _this2.handleResponse(result);
    })();
  }

  handleResponse(response) {
    if (response.statusCode === "error") {
      throw new Error(response.error || response.body);
    }

    return response.body;
  }

}

export default UserClient;
//# sourceMappingURL=index.js.map